<template>
  <div class="d-flex flex-column align-center justify-space-between">
    <div class="text-center">
      {{ name }}
    </div>
    <div>
      <v-rating length="1"
                dense
                readonly
                :value="internalValue"
                size="70"
                empty-icon="mdi-star-outline"
                full-icon="mdi-star"
                color="secondary"
      />
      <div class="text-center">
        +{{ weight }}%
      </div>
    </div>
  </div>

</template>
<script>
import Component from 'vue-class-component';
import Vue from 'vue';
import { Prop } from 'vue-property-decorator';

@Component
export default class CompletionStar extends Vue {
  @Prop({ type: Boolean, required: true }) value;

  @Prop({ type: Number, required: true }) weight;

  @Prop({ type: String, required: true }) name;

  get internalValue() {
    return this.value ? 1 : 0;
  }
}
</script>
